import script from "./IntegrationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegrationView.vue?vue&type=script&setup=true&lang=ts"

import "./IntegrationView.vue?vue&type=style&index=0&id=bd12e796&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd12e796"]])

export default __exports__